<template>
  <div class="app-container">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="@/assets/back.png" alt="返回" />
          <span>返回</span>
        </div>
      </div>

      <!-- 基础信息 -->
      <Title class="mt20">基础信息</Title>
      <div class="basic-info">
        <div class="info-item">
          <div class="product-image">
            <el-image :src="info.coverImage" alt="产品图片" class="product-img"  style="width: 70%; height: 70%;"
            :preview-src-list="info.coverImage ? [info.coverImage] : []" fit="cover" />
          </div>
          <div class="title-with-product">
            <p>
              <span v-for="(item, index) in info.titleDisplay" :key="index"
                >{{ item.titleName }}【{{
                  item.isEdit ? "可编辑" : "不可编辑"
                }}】</span
              >
            </p>
            <p class="p1">发布者：{{ operatedUserPO.realName || "--" }}</p>
            <p class="p1">创建时间：{{ operatedUserPO.createdTime || "--" }}</p>
          </div>
        </div>
        <el-descriptions :column="3">
          <el-descriptions-item label="分类">{{
            info.classificationName
          }}</el-descriptions-item>
          <!-- <el-descriptions-item label="会议类型">{{
            info.meetingName
          }}</el-descriptions-item> -->
          <el-descriptions-item label="会议">{{
            info.meetingName
          }}</el-descriptions-item>
          <el-descriptions-item label="虚拟浏览量">{{
            info.browseNum || 0
          }}</el-descriptions-item>
          <el-descriptions-item label="虚拟点赞量">{{
            info.likeNum || 0
          }}</el-descriptions-item>
          <el-descriptions-item label="虚拟转发量">{{
            info.forwardNum || 0
          }}</el-descriptions-item>
          <el-descriptions-item label="页面排序">{{
            info.orderNo
          }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{
            info.state === 1 ? "启用" : info.state === 0 ? "禁用" : "--"
          }}</el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 文章详情 -->
      <Title class="mt20">文章详情</Title>
      <el-descriptions :column="2">
        <el-descriptions-item label="文章logo图">
          <el-image
            v-if="info.logoImg"
            style="width: 50px; height: 50px; border-radius: 50%"
            :src="info.logoImg"
            :preview-src-list="[info.logoImg]"
          ></el-image>
        </el-descriptions-item>
        <el-descriptions-item label="技术老师描述"
          >{{
            info.teacherIsEdit === 1 ? "可" : "不可"
          }}分享时更换技术老师</el-descriptions-item
        >
        <el-descriptions-item label="默认技术老师">
          <el-image
            v-if="templateTeacher&&templateTeacher.promotionImg"
            style="width: 200px; height: 100px; "
            :src="templateTeacher.promotionImg"
            :preview-src-list="[templateTeacher.promotionImg]"
          ></el-image>
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="3">
        <el-descriptions-item label="时间">{{
          info.contactTime
        }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{
          info.contactName
        }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{
          info.contactPho
        }}</el-descriptions-item>
        <el-descriptions-item label="地址">{{
          info.contactAddress
        }}</el-descriptions-item>
      </el-descriptions>

      <!-- 内容 -->
      <Title class="mt20">内容</Title>
      <div class="content-section">
        <div class="content-blocks">
          <div
            v-for="(item, idx) in contentList"
            :key="idx"
            class="content-block mb10"
            :class="item.isEdit === 1 ? 'editable-block' : 'non-editable-block'"
          >
            <div class="block-content">
              <div class="block-features">
                <div class="feature-item" v-html="item.content"></div>
              </div>
            </div>
            <div
              class="block-tag"
              :class="item.isEdit === 1 ? 'editable-tag' : 'non-editable-tag'"
            >
              {{ item.isEdit === 1 ? "可编辑" : "不可编辑" }}
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import templateMaterialsShareApi from "@/api/marketing/templateMaterialsShare";
export default {
  props: ["rowItem"],
  data() {
    return {
      info: {},
      contentList: [],
      contentText: "",
      operatedUserPO: {},
      templateTeacher:{},
      defaultThumbnail:
        "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDIwMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMTIwIiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAiIHkxPSIwIiB4Mj0iMjAwIiB5Mj0iMTIwIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiM5OTk5OTk7c3RvcC1vcGFjaXR5OjEiLz4KPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojZmZmZmZmO3N0b3Atb3BhY2l0eToxIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPHN2ZyB4PSI1MCIgeT0iMzAiIHdpZHRoPSIxMDAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCAxMDAgNjAiIGZpbGw9Im5vbmUiPgo8dGV4dCB4PSI1MCIgeT0iMzUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzMzMyIgdGV4dC1hbmNob3I9Im1pZGRsZSI+5Zu+54mH5Y2gPC90ZXh0Pgo8L3N2Zz4KPC9zdmc+"
    };
  },
  created() {
    this.handleShow();
  },
  methods: {
    parseContentList(input) {
      try {
        const arr = typeof input === "string" ? JSON.parse(input) : input;
        if (Array.isArray(arr)) return arr;
      } catch (e) {}
      return [];
    },
    isTitleEditable(list) {
      try {
        const arr = typeof list === "string" ? JSON.parse(list) : list;
        if (Array.isArray(arr)) {
          return arr.some(it => Number(it && it.isEdit) === 1);
        }
      } catch (e) {}
      return false;
    },
    handleShow() {
      templateMaterialsShareApi.fetchById(this.rowItem.id).then(res => {
        const responseData = res.data || {};
        const sharePO = responseData.templateMaterialsSharePO || {};
        const classification = responseData.templateClassification || {};
        const meeting = responseData.meeting || {};
        const operatedUserPO = responseData.operatedUserPO || {};
        const templateTeacher=responseData.templateTeacher || {};
         this.templateTeacher=templateTeacher;
        // 保存发布者信息
        this.operatedUserPO = operatedUserPO;

        // 构建 info 对象，合并所有数据
        const info = {
          // 从 templateMaterialsSharePO 获取主要信息
          ...sharePO,
          // 分类信息
          classificationName: classification.name || "--",
          // 会议信息
          meetingName: meeting.title || "--",
          // 标题显示
          titleDisplay: sharePO.titleJson
            ? this.parseTitleJson(sharePO.titleJson)
            : [],
          // 封面图
          coverImage: sharePO.coverImage || "",
          // logo图
          logoImg: sharePO.logoImg || "",
          // 浏览量
          browseNum: sharePO.browseNum || 0,
          // 点赞量
          likeNum: sharePO.likeNum || 0,
          // 转发量
          forwardNum: sharePO.forwardNum || 0,
          // 排序
          orderNo: sharePO.orderNo || 0,
          // 状态
          state: sharePO.state,
          // 联系人信息
          contactTime: sharePO.contactTime || "--",
          contactName: sharePO.contactName || "--",
          contactPho: sharePO.contactPho || "--",
          contactAddress: sharePO.contactAddress || "--",
          // 技术老师相关
          teacherIsEdit: sharePO.teacherIsEdit,
          // 发布者和创建时间
          createdBy: sharePO.createdBy || "--",
          createdTime: sharePO.createdTime || "--"
        };

        // 解析内容列表
        this.contentList = this.parseContentList(sharePO.content);
        this.contentText = this.contentList
          .map(it => (it && it.content) || "")
          .join("\n");
        this.info = info;
      });
    },
    parseTitleJson(titleJson) {
      try {
        if (!titleJson) return [];
        const list =
          typeof titleJson === "string" ? JSON.parse(titleJson) : titleJson;
        if (!Array.isArray(list)) return [];
        return list;
      } catch (e) {
        return [];
      }
    },
    handleBack() {
      this.$emit("handleShow", "", 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.info-item {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  .product-image {
    width: 172px;
    height: 96px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title-with-product {
    p {
      &:first-child {
        margin-top: 0;
      }
    }
    .p1 {
      font-size: 14px;
      color: #6c6c6c;
    }
  }
}

.virtual-value {
  color: #1596cd;
  font-weight: 500;
}

.status-enabled {
  color: #67c23a;
  font-weight: 500;
}

// 文章详情样式
.article-logo {
  .logo-img {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #e4e7ed;
  }
}

.teacher-desc {
  display: flex;
  align-items: center;
  gap: 10px;

  .teacher-product-image {
    .teacher-product-img {
      width: 60px;
      height: 60px;
      object-fit: cover;
      border-radius: 6px;
      border: 1px solid #e4e7ed;
    }
  }
}

// 内容部分样式
.content-section {
  .main-content-text {
    font-size: 14px;
    color: #2e2f3e;
    line-height: 1.8;
    padding: 15px 0;
    word-break: break-all;
    margin-bottom: 20px;
  }

  .content-blocks {
    // display: flex;
    // gap: 20px;
    // flex-wrap: wrap;

    .content-block {
      position: relative;
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      padding: 15px;
      background: #fafafa;
      // min-width: 200px;

      .block-content {
        .block-image {
          margin-bottom: 10px;

          .content-img {
            width: 100%;
            max-width: 150px;
            height: 120px;
            object-fit: cover;
            border-radius: 6px;
            border: 1px solid #e4e7ed;
          }
        }

        .block-features {
          .feature-item {
            display: flex;
            align-items: center;
            margin-bottom: 5px;

            .checkmark {
              color: #67c23a;
              margin-right: 8px;
              font-weight: bold;
            }

            span:last-child {
              font-size: 14px;
              color: #2e2f3e;
            }
          }
        }
      }

      .block-tag {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 12px;
        padding: 2px 6px;
        border-radius: 4px;

        &.editable-tag {
          color: #67c23a;
          background: #f0f9ff;
          border: 1px solid #67c23a;
        }

        &.non-editable-tag {
          color: #909399;
          background: #f5f7fa;
          border: 1px solid #909399;
        }
      }

      &.editable-block {
        border-color: #67c23a;
        background: #f0f9ff;
      }

      &.non-editable-block {
        border-color: #909399;
        background: #f5f7fa;
      }
    }
  }
}

.el-divider {
  margin: 30px 0;
}
</style>
